import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CopyToClipboardCustom } from '../../CopyToClipboardCustom';
import { getValorizacionTurno, getTurnosCtaCtePorGrupo } from "../../../actions/turnos/ctaCte";
import { PopupRequiereAutorizacion } from './PopupRequiereAutorizacion';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        padding: 10,
        marginTop: 20
    }
}));

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export const DetallesTurno = (idObraSocial) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { afiliado } = useSelector((state) => state.afiliacion);
    const { seleccionado } = useSelector((state) => state.agenda);
    const { saldo = 0, valorizacionTurno } = useSelector((state) => state.ctaCte);
    const { codNomAutor } = useSelector((state) => state.cosegurosExternos);
    const [requiereAutorizacion, setRequiereAutorizacion] = useState(false);


    useEffect(() => {
        if (Array.isArray(codNomAutor) && codNomAutor.length > 0) {
          setRequiereAutorizacion(true);
        } else {
          setRequiereAutorizacion(false);
        }
      }, [codNomAutor]);

    useEffect(() => {
        if (afiliado.idGrupoFamiliar > 1)
            dispatch(getTurnosCtaCtePorGrupo(afiliado.idGrupoFamiliar));
        if (seleccionado.idTipoTurno === 1)
            dispatch(getValorizacionTurno(seleccionado.idAgenda, afiliado?.idObraSocial, afiliado.externo));
    }, [dispatch, afiliado.idGrupoFamiliar]);

    return (
        <div className={classes.root}>
            {requiereAutorizacion &&
                <PopupRequiereAutorizacion
                    open={requiereAutorizacion}
                    close={() => {
                        setRequiereAutorizacion(false);
                    }}
                    codNomAutor={codNomAutor}
                />

            }
            <Grid container justify="center" spacing={1} style={{ marginTop: 10, marginBottom: 15 }}>
                <Grid >
                    <Typography variant="h5" component="h3" >
                        <strong>Detalles del Turno</strong>
                    </Typography>
                </Grid>
            </Grid>
            <Grid container justify="center" spacing={1}>
                <Grid item xs={8}>
                    <Typography variant="h6" class="typografy">
                        <strong>Afiliado: </strong>{afiliado.apellido_y_nombre}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container justify="center" spacing={1}>
                <Grid item xs={8}>
                    <Typography variant="h6" class="typografy">
                        <strong>CUIL: </strong>{afiliado.cuil}
                        <CopyToClipboardCustom text={afiliado.cuil} />
                    </Typography>
                </Grid>
            </Grid>
            <Grid container justify="center" spacing={1} >
                <Grid item xs={4}>
                    <Typography variant="h6" class="typografy">
                        <strong>Fecha: </strong>{new Date(seleccionado.fecha).toLocaleString("es", optionsfecha)}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="h6" class="typografy">
                        <strong>Hora: </strong>{seleccionado.hora}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container justify="center" spacing={1}>
                <Grid item xs={8}>
                    <Typography variant="h6" class="typografy">
                        <strong>Profesional: </strong>{seleccionado.efectorRed.nombreEfector}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container justify="center" spacing={1}>
                <Grid item xs={8}>
                    <Typography variant="h6" class="typografy">
                        <strong>Especialidad: </strong>{seleccionado.especialidad.descripcionEspecialidades}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container justify="center" spacing={1}>
                <Grid item xs={8}>
                    <Typography variant="h6" class="typografy">
                        <strong>Modalidad: </strong>{seleccionado.idTipoTurno === 1 ? 'Presencial' : 'Virtual'}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container justify="center" spacing={1}>
                <Grid item xs={8}>
                    <Typography variant="h6" class="typografy">
                        <strong>Centro Medico: </strong>{seleccionado.centroMedico.descripcionCentro}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container justify="center" spacing={1} style={{ marginBottom: 15 }}>
                <Grid item xs={8}>
                    <Typography variant="h6" class="typografy">
                        <strong>Domicilio: </strong>{seleccionado.centroMedico.direccion}
                    </Typography>
                </Grid>
            </Grid>
            {valorizacionTurno && seleccionado.idTipoTurno === 1 &&
                <Grid container justify="center" spacing={1} style={{ marginBottom: 15 }}>
                    <Grid item xs={8}>
                        <Typography variant="h6" component="h2" style={{ marginLeft: 10, color: valorizacionTurno.exento && 'red' }}>
                            <strong>Importe Turno: </strong>{valorizacionTurno.exento ? 'EXENTO' : valorizacionTurno.importe.toFixed(2)}
                        </Typography>
                    </Grid>
                </Grid>
            }
            {!afiliado.externo &&
                <Grid container justify="center" spacing={1} style={{ marginBottom: 15 }}>
                    <Grid item xs={8}>
                        {saldo === 0 &&
                            <Typography variant="h6" component="h2" style={{ marginLeft: 10 }}>
                                <strong>Saldo en CtaCte: ${saldo.toFixed(2)}</strong>
                            </Typography>}
                        {saldo < 0 &&
                            <Typography variant="h6" component="h2" style={{ marginLeft: 10, color: 'green' }}>
                                <strong>Saldo en CtaCte: ${(saldo * -1).toFixed(2)}</strong>
                            </Typography>}
                        {saldo > 0 &&
                            <Typography variant="h6" component="h2" style={{ marginLeft: 10, color: 'red' }}>
                                <strong>Saldo en CtaCte Deuda: ${saldo.toFixed(2)}</strong>
                            </Typography>}
                    </Grid>
                </Grid>
            }
        </div>
    );

};
